<style>
#information {
  /* padding: 30px 30px 8px 30px !important; */
  height: calc(100vh - 128px) !important;
}
#information .q-table__middle {
  overflow-y: hidden !important;
  overflow-x: auto !important;
  height: calc(100% - 48px) !important;
  width: 100%;
}
#information .q-table {
  overflow: hidden !important;
  height: 100% !important;
  width: 100%;
}
#information tbody {
  display: block;
  max-height: calc(100vh - 300px);
  height: 100%;
  width: 100%;
  overflow: auto;
  webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
#information .q-table thead {
  height: 48px;
  display: block;
}
#information .q-table thead tr {
  width: 100%;
  display: table;
}
#information .q-table tbody tr {
  width: 100%;
  display: table; /*table-row*/
}
#information .q-table th,
#codeLog .q-table tbody td {
  font-size: 0.95rem;
}
#information .q-table th,
#codeLog .q-table td {
  padding: 7px 8px;
}
#information .q-table td {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
#information .q-table__bottom {
  color: #888;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 15px;
}
#information .q-table__bottom,
#information .q-table__bottom .q-if {
  font-size: 0.88rem;
}
.my-sticky-header-table thead tr th {
  position: sticky;
  z-index: 1;
}
.my-sticky-header-table thead tr:first-child th {
  background-color: #ffffff;
}
.my-sticky-header-table thead tr:first-child th {
  top: 0;
}
.q-editor__content {
  min-height: 15rem !important;
  max-height: 15rem;
  overflow-y: auto;
}
</style>

<template>
  <q-page id="information" padding :style="{ padding: screenType ? '30px 30px 8px 30px!important' : '8px' }">
    <!-- 表格展示区域 -->
    <q-card class="fit">
      <q-card-section style="height: 60px;padding:10px 15px;">
        <q-btn @click="addMessage()" label="添加通知" icon="fas fa-plus fa-1x" color="positive"></q-btn>
        <template v-if="screenType">
          <q-input v-model="keyword" :placeholder="$t('key')" maxlength="15" style="width:240px;float:right" rounded outlined dense>
            <template v-slot:after>
              <q-btn icon="fa fa-search" color="white" text-color="primary" round dense @click="getdata(1)" />
            </template>
          </q-input>
          <!-- 结束时间选择 -->
          <q-input
            v-model="endTime"
            class="q-mr-sm"
            placeholder="结束时间"
            mask="date"
            :input-style="{ textAlign: 'center' }"
            outlined
            dense
            clearable
            style="float:right;width:150px;padding:0;"
          >
            <template v-slot:prepend>
              <q-icon name="fa fa-calendar-day fa-xs" class="cursor-pointer"></q-icon>
            </template>
            <q-popup-proxy>
              <q-date v-model="endTime" :options="endTimeFn" />
            </q-popup-proxy>
          </q-input>
          <!-- 起始时间选择 -->
          <q-input
            v-model="startTime"
            class="q-mr-sm"
            placeholder="起始时间"
            mask="date"
            :input-style="{ textAlign: 'center' }"
            outlined
            dense
            clearable
            style="float:right;width:150px;padding:0;"
          >
            <template v-slot:prepend>
              <q-icon name="fa fa-calendar-day fa-xs" class="cursor-pointer"></q-icon>
            </template>
            <q-popup-proxy>
              <q-date v-model="startTime" :options="startTimeFn" />
            </q-popup-proxy>
          </q-input>
          <q-select
            v-model="searcUserId"
            :options="userList"
            map-options
            option-value="id"
            option-label="name"
            emit-value
            dense
            clearable
            filled
            @input="searchUser"
            style="float:right;min-width:120px"
            label="查询用户"
            class="q-mr-sm"
          ></q-select>
        </template>
        <template v-else>
          <q-btn label="筛选条件入口" @click="mobileSearch = true" style="float:right"></q-btn>
        </template>
      </q-card-section>
      <q-separator />
      <!-- 所有消息操作 -->
      <q-card-section class="q-pa-none" style="height:calc(100% - 60px);">
        <q-table
          class="fit my-sticky-header-table"
          :data="listData"
          :columns="columns"
          :loading="loading"
          :pagination.sync="page"
          :rows-per-page-options="[15, 20, 30]"
          row-key="id"
        >
          <tr slot="header" slot-scope="props">
            <q-th key="title" :props="props" style="width:16%;min-width: 150px">标题</q-th>
            <q-th key="publishTime" :props="props" style="width:16%;min-width: 150px">发布时间</q-th>
            <q-th key="type" :props="props" style="width:8%;min-width: 150px">类型</q-th>
            <!-- <q-th key="customerId" :props="props" style="width:13%;">客户</q-th> -->
            <!-- <q-th key="targetType" :props="props" style="width:8%;">目标类型</q-th> -->
            <q-th key="targetId" :props="props" style="width:8%;min-width: 150px">用户</q-th>
            <q-th key="status" :props="props" style="width:8%;min-width: 150px">是否发布</q-th>
            <q-th key="check" :props="props" style="width:8%;min-width: 150px">是否已读</q-th>
            <q-th key="opt" :props="props" style="width:15%;min-width:135px;">操作</q-th>
          </tr>
          <q-tr slot="body" slot-scope="props" :props="props">
            <q-td key="title" :props="props" style="width:16%;min-width: 150px" class="ellipsis">{{ props.row.title }}</q-td>
            <q-td key="publishTime" :props="props" style="width:16%;min-width: 150px">{{ props.row.publishTime | parseDateTime }}</q-td>
            <q-td key="type" :props="props" style="width:8%;min-width: 150px">
              <q-badge color="red" v-if="props.row.type === 1">严重</q-badge>
              <q-badge color="primary" v-if="props.row.type === 2">普通</q-badge>
              <q-badge color="warning" v-if="props.row.type === 3">警告</q-badge>
            </q-td>
            <!-- <q-td key="customerId" :props="props" style="width:13%;">{{props.row.customerId}}</q-td> -->
            <!-- <q-td key="targetType" :props="props" style="width:8%;">
              <span v-if="props.row.targetType === 1">用户</span>
              <span v-if="props.row.targetType === 2">客户</span>
              <span v-if="props.row.targetType === 3">其他</span>
            </q-td> -->
            <q-td key="targetId" :props="props" style="width:8%;min-width: 150px">
              <template v-for="listData in userList">
                <span :key="listData.id" v-if="listData.id === props.row.targetId">{{ listData.name }}</span>
              </template>
            </q-td>
            <q-td key="status" :props="props" style="width:8%;min-width: 150px">
              <q-badge color="secondary" v-if="props.row.status === 1">已发布</q-badge>
              <q-badge color="green" v-if="props.row.status === 2">待发布</q-badge>
            </q-td>
            <q-td key="check" :props="props" style="width:8%;min-width: 150px">
              <q-badge color="secondary" v-if="props.row.check === 1">已读</q-badge>
              <q-badge color="green" v-if="props.row.check === 0">未读</q-badge>
            </q-td>
            <q-td key="opt" :props="props" style="width:15%;min-width:135px;">
              <q-btn v-if="props.row.status !== 1" icon="fa fa-paper-plane" color="primary" size="sm" @click="btnClick(2, props)" flat round dense>
                <q-tooltip :offset="[5, 5]" anchor="top middle" self="bottom middle">{{ $t("send") }}</q-tooltip>
              </q-btn>
              <q-btn icon="fa fa-search" color="positive" size="sm" class="q-ml-sm" @click="btnClick(3, props)" flat round dense>
                <q-tooltip :offset="[5, 5]" anchor="top middle" self="bottom middle">{{ $t("detail") }}</q-tooltip>
              </q-btn>
              <q-btn icon="fas fa-edit" color="amber-7" class="q-ml-sm" size="sm" @click="btnClick(1, props)" flat round dense>
                <q-tooltip :offset="[5, 5]" anchor="top middle" self="bottom middle">{{ $t("edit") }}</q-tooltip>
              </q-btn>
              <q-btn icon="fas fa-trash-alt" color="red" class="q-ml-sm" size="sm" @click="btnClick(4, props)" flat round dense>
                <q-tooltip :offset="[5, 5]" anchor="top middle" self="bottom middle">{{ $t("delete") }}</q-tooltip>
              </q-btn>
            </q-td>
          </q-tr>
          <div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
            <q-btn @click="pageClick(0)" :disable="curPage <= 1" icon="fas fa-arrow-left" color="primary" size="sm" round />
            <div class="q-mx-md" style="font-size: small">{{ curPage }} / {{ totalPage }}</div>
            <q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round />
          </div>
        </q-table>
      </q-card-section>
    </q-card>
    <!-- 添加消息弹出区域 -->
    <q-dialog v-model="addMessageDispaly">
      <q-card :class="[screenType ? 'q-pa-lg' : 'q-pa-sm']" :style="{ minWidth: screenType ? '60vw' : '85vw', width: screenType ? '' : '65vw' }">
        <q-card-section class="q-pa-lg">
          <div class="text-h6">通知编写</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="fit">
            <div :class="screenType ? 'row justify-around' : 'column justify-center items-center'">
              <q-input
                ref="title"
                :rules="[(val) => !!val || '请填写消息标题']"
                :class="screenType ? 'col-4' : 'col-12 full-width'"
                v-model.trim="form.title"
                label="消息标题"
                placeholder="标题"
                dense
                lazy-rules
              />
              <q-select
                ref="Typeselect"
                :class="screenType ? 'col-4' : 'col-12 full-width'"
                v-model="form.type"
                :options="Typeoptions"
                :rules="[(val) => !!val || '请选择消息类型']"
                label="消息类型"
                option-value="value"
                option-label="label"
                emit-value
                map-options
                dense
                lazy-rules
              />
            </div>
            <div :class="screenType ? 'row q-mt-sm justify-around' : 'column justify-center items-center'" v-if="!editMessagebtn">
              <q-select
                ref="targetType"
                :class="screenType ? 'col-4' : 'col-12 full-width'"
                v-model="form.targetType"
                :options="targetTypeList"
                :rules="[(val) => !!val || '请选择目标类型']"
                map-options
                option-value="value"
                option-label="label"
                emit-value
                dense
                label="目标类型"
              />
              <q-select
                ref="customer"
                :class="screenType ? 'col-4' : 'col-12 full-width'"
                v-model="form.customerId"
                :options="customerList"
                :rules="[(val) => !!val || '请选择客户']"
                map-options
                option-value="id"
                option-label="customerName"
                emit-value
                dense
                label="客户"
              />
            </div>
          </div>
          <q-editor class="q-mt-md" v-model="form.content" dense :toolbar="editorOptions" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="CANCEL" color="primary" v-close-popup />
          <q-btn v-if="!editMessagebtn" flat label="OK" color="primary" @click="SureConfirm(1)" />
          <q-btn v-if="editMessagebtn" flat label="OK" color="primary" @click="SureConfirm(2)" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- 消息查看按钮弹出区域 -->
    <q-dialog v-model="detailMessageDisplay">
      <q-card :class="[screenType ? 'q-pa-lg' : 'q-pa-sm']" :style="{ minWidth: screenType ? '450px' : '85vw', width: screenType ? '' : '65vw' }">
        <q-card-section>
          <div class="text-h6">消息详情</div>
        </q-card-section>

        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>标题:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ form.title }}</q-item-label>
          </q-item-section>
        </q-item>

        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>创建者类型:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>
              <template v-if="form.publisherType == 0"
                >系统</template
              >
              <template v-if="form.publisherType == 1"
                >管理员</template
              >
              <template v-if="form.publisherType == 2"
                >用户</template
              >
            </q-item-label>
          </q-item-section>
        </q-item>

        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>用户:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>
              <template v-for="listData in userList">
                <span :key="listData.id" v-if="listData.id === form.targetId">{{ listData.name }}</span>
              </template>
            </q-item-label>
          </q-item-section>
        </q-item>

        <!-- <q-item dense>
          <q-item-section avatar>
            <q-item-label header>目标类型:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label v-if="form.targetType == 1">用户(客户管理员与用户可见)</q-item-label>
            <q-item-label v-if="form.targetType == 2">客户(仅为客户管理员可见)</q-item-label>
            <q-item-label v-if="form.targetType == 3">其他</q-item-label>
          </q-item-section>
        </q-item> -->

        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>类型:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>
              <q-badge color="red" v-if="form.type === 1">严重</q-badge>
              <q-badge color="primary" v-if="form.type === 2">普通</q-badge>
              <q-badge color="warning" v-if="form.type === 3">警告</q-badge>
            </q-item-label>
          </q-item-section>
        </q-item>
        <!-- <q-item dense>
          <q-item-section avatar>
            <q-item-label header>read:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>
              <q-badge color="secondary" v-if="form.read === 0">未读</q-badge>
              <q-badge color="green" v-if="form.read === 1">已读</q-badge>
            </q-item-label>
          </q-item-section>
        </q-item>-->
        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>发布时间:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ form.publishTime | parseDateTime }}</q-item-label>
          </q-item-section>
        </q-item>
        <q-item dense>
          <q-item-section avatar>
            <q-item-label header>内容:</q-item-label>
          </q-item-section>
          <q-item-section>
            <q-card>
              <q-card-section v-html="form.content" style="max-height: 300px;overflow-y:auto;"></q-card-section>
            </q-card>
            <!-- <q-item-label style="word-break: break-word;"></q-item-label> -->
          </q-item-section>
        </q-item>
      </q-card>
    </q-dialog>
    <!-- 消息删除按钮弹出区域 -->
    <q-dialog v-model="deleteMessageDisplay">
      <q-card style="width: 300px;">
        <q-card-section>
          <div class="text-h6" style="color:red">警告</div>
        </q-card-section>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">确认删除该消息?</span>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="NO" color="primary" v-close-popup />
          <q-btn flat label="YES" color="red" @click="deleteMessage" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- 询问是否立即发布消息区域 -->
    <q-dialog v-model="sendNowMessageDisplay">
      <q-card>
        <q-card-section>
          <div class="text-h6" style="color:red">注意</div>
        </q-card-section>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">确认立即发送消息吗？</span>
        </q-card-section>
        <q-card-actions align="right" v-if="isAdd">
          <q-btn flat label="不了" color="primary" @click="sendNotMessage()" />
          <q-btn flat label="是的" color="primary" @click="confirm(1)" />
        </q-card-actions>
        <q-card-actions align="right" v-else>
          <q-btn flat label="不了" color="primary" v-close-popup />
          <q-btn flat label="是的" color="primary" @click="publishStatus" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- 移动端查询条件弹窗 -->
    <q-dialog v-model="mobileSearch">
      <q-card :class="[screenType ? 'q-pa-lg' : 'q-pa-sm']" :style="{ minWidth: screenType ? '60vw' : '85vw', width: screenType ? '' : '65vw' }">
        <q-card-section>
          <div class="text-h6">筛选条件</div>
        </q-card-section>
        <q-card-section class="column q-gutter-y-sm">
          <q-input v-model="keyword" :placeholder="$t('key')" maxlength="15"  outlined dense>
            <template v-slot:after> </template>
          </q-input>
          <!-- 起始时间选择 -->
          <q-input v-model="startTime" class="col-12" placeholder="起始时间" mask="date" :input-style="{ textAlign: 'center' }" outlined dense clearable style="padding:0;">
            <template v-slot:prepend>
              <q-icon name="fa fa-calendar-day fa-xs" class="cursor-pointer"></q-icon>
            </template>
            <q-popup-proxy>
              <q-date v-model="startTime" :options="startTimeFn" />
            </q-popup-proxy>
          </q-input>
          <!-- 结束时间选择 -->
          <q-input v-model="endTime" class="col-12" placeholder="结束时间" mask="date" :input-style="{ textAlign: 'center' }" outlined dense clearable style="padding:0;">
            <template v-slot:prepend>
              <q-icon name="fa fa-calendar-day fa-xs" class="cursor-pointer"></q-icon>
            </template>
            <q-popup-proxy>
              <q-date v-model="endTime" :options="endTimeFn" />
            </q-popup-proxy>
          </q-input>

          <q-select
            v-model="searcUserId"
            :options="userList"
            map-options
            option-value="id"
            option-label="name"
            emit-value
            dense
            clearable
            filled
            @input="searchUser"
            label="查询用户"
          ></q-select>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="关闭" color="primary" v-close-popup />
          <q-btn flat label="查询" color="primary" @click="getdata(1)" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
export default {
  data() {
    return {
      tab: "mails",
      keyword: null,
      startTime: null,
      endTime: null,
      userInfo: {},
      listData: [],
      total: 1,
      curPage: 1,
      page: { page: 1, rowsPerPage: 20 },
      loading: false,
      columns: [
        // { name: "id", field: "id", align: "left" },
        { name: "title", field: "title", align: "left", },
        { name: "publishTime", field: "publishTime", align: "left", },
        { name: "type", field: "type", align: "left", sortable: true },
        // { name: "customerId", field: "type", align: "left", sortable: true },
        // { name: "targetType", field: "type", align: "left", sortable: true },
        { name: "targetId", field: "type", align: "left", sortable: true },
        { name: "status", field: "status", align: "left", sortable: true },
        { name: "check", field: "check", align: "left", sortable: true },
        { name: "opt", field: "opt", align: "left" },
      ],
      addMessageDispaly: false,
      sendNowMessageDisplay: false,
      detailMessageDisplay: false,
      deleteMessageDisplay: false,
      editMessagebtn: false,
      mobileSearch: false,
      form: {},
      content: {
        title: null,
        content: "",
        type: null,
        customerId: null,
        targetType: 1,
      },
      Typeoptions: [{ label: "严重", value: 1 }, { label: "普通", value: 2 }, { label: "警告", value: 3 }],
      editorOptions: [
        [
          {
            label: "对齐方式",
            fixedLabel: true,
            list: "only-icons",
            options: ["left", "center", "right", "justify"],
          },
        ],
        ["bold", "italic", "strike", "underline", "subscript", "superscript"],
        ["token", "hr", "link", "custom_btn"],
        [
          {
            label: "标题大小",
            list: "no-icons",
            options: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "code"],
          },
          {
            label: "字体大小",
            fixedLabel: true,
            fixedIcon: true,
            list: "no-icons",
            options: ["size-1", "size-2", "size-3", "size-4", "size-5", "size-6", "size-7"],
          },
          "removeFormat",
        ],
        ["quote", "unordered", "ordered", "outdent", "indent"],
        ["undo", "redo"],
      ],
      customerList: [],
      userList: [],
      targetTypeList: [{ label: "用户(客户管理员与用户可见)", value: 1 }, { label: "客户", value: 2 }, { label: "其他", value: 3 }],
      searcUserId: null,
      isAdd: false,
    };
  },
  props: ["lang", "user"],
  filters: {
    parseDateTime(time) {
      return time ? parseDateTime(time) : time;
    },
  },
  computed: {
    screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
    nextPage() {
      return this.curPage >= Math.ceil(this.total / this.page.rowsPerPage);
    },
    totalPage() {
      return Math.ceil(this.total / this.page.rowsPerPage);
    },
    pageCount() {
      return this.page.rowsPerPage;
    },
  },
  mounted() {
    this.getcustomerListData();
    this.getclientUserListData();
    setTimeout(() => {
      // this.getdata(1);
      this.userInfo = this.user;
    }, 200);
  },
  created() {
    this.form = JSON.parse(JSON.stringify(this.content));
    if (localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length > 0) {
      this.getdata(1);
    } else {
      this.$router.replace("/"); //login
    }
  },
  watch: {
    custom(val, oldVal) {
      this.getdata(1);
    },
  },
  methods: {
    startTimeFn(date) {
      if (this.endTime) {
        return date <= this.endTime;
      } else {
        return date <= parseDate1(DATE.getTime());
      }
    },
    endTimeFn(date) {
      if (this.startTime) {
        return date >= this.startTime && date <= parseDate1(DATE.getTime());
      } else {
        return date <= parseDate1(DATE.getTime());
      }
    },
    // 新增消息按钮弹窗区域
    addMessage() {
      this.editMessagebtn = false;
      this.form = JSON.parse(JSON.stringify(this.content));
      this.addMessageDispaly = true;
      this.isAdd = true;
    },
    sendNotMessage() {
      this.sendNowMessageDisplay = false;
      this.addMessageDispaly = false;
      this.confirm(2);
    },
    // 删除消息请求
    deleteMessage() {
      // let id, customerId;
      let id = this.form.id;
      let targetId = this.form.targetId;
      let IdsArr = [];
      IdsArr.push(id);
      let request = {
        ids: IdsArr,
        targetId: targetId,
      };
      // customerId = this.form.customerId;
      this.$ajax(1, "delete", true, "/system/sentMessage", request)
        .then((res) => {
          if (res.code === 20000) {
            this.deleteMessageDisplay = false;
            this.form = JSON.parse(JSON.stringify(this.content));
            this.$notify(1, "删除成功", null, false);
            this.getdata(1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 更新消息请求
    UpdateMessage() {
      let request = {};
      request = {
        id: this.form.id,
        // customerId: this.searchCustomerId,
        title: this.form.title,
        content: this.form.content,
        type: this.form.type,
        status: this.form.status,
      };
      this.$ajax(1, "post", true, "/system/updateMessage", request)
        .then((res) => {
          if (res.code === 20000) {
            this.addMessageDispaly = false;
            this.getdata(1);
            this.$notify(1, "修改成功", null, false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发布状态改变
    publishStatus() {
      let request = {
        id: this.form.id,
        // customerId: this.form.customerId,
        title: this.form.title,
        content: this.form.content,
        type: this.form.type,
        status: 1,
      };
      this.$ajax(1, "post", true, "/system/updateMessage", request)
        .then((res) => {
          if (res.code === 20000) {
            this.sendNowMessageDisplay = false;
            this.getdata(1);
            this.$notify(1, "发布成功", null, false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    btnClick(type, props) {
      // this.form = JSON.parse(JSON.stringify(props.row));
      if (type === 1) {
        // 消息编写弹出
        this.form = JSON.parse(JSON.stringify(props.row));
        this.editMessagebtn = true;
        this.addMessageDispaly = true;
      } else if (type === 2) {
        // 发送消息弹出
        this.form = JSON.parse(JSON.stringify(props.row));
        this.isAdd = false;
        this.sendNowMessageDisplay = true;
      } else if (type === 3) {
        // 消息详情弹出
        this.form = JSON.parse(JSON.stringify(props.row));
        this.detailMessageDisplay = true;
      } else if (type === 4) {
        // 删除消息弹出
        this.form = JSON.parse(JSON.stringify(props.row));
        this.deleteMessageDisplay = true;
      }
    },
    // 获取客户列表
    getcustomerListData() {
      let request = {};
      request.paging = {
        index: 0,
        count: -1,
        sort: "desc",
      };
      this.$ajax(1, "post", true, "/customer/list", request)
        .then((res) => {
          this.customerList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取用户列表
    getclientUserListData() {
      let request = {};
      request.paging = {
        index: 0,
        count: -1,
        sort: "desc",
      };
      this.$ajax(1, "post", true, "/clientUser/list", request)
        .then((res) => {
          this.userList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchUser() {
      this.page = { page: 1, rowsPerPage: 20 };
      this.total = 1;
      this.curPage = 1;
      this.getdata(1);
    },
    // 对填写内容验证
    SureConfirm(type) {
      if (type === 1) {
        this.$refs.title.validate();
        this.$refs.Typeselect.validate();
        this.$refs.customer.validate();
        this.$refs.targetType.validate();
      } else if (type === 2) {
        this.$refs.title.validate();
        this.$refs.Typeselect.validate();
      }
      if (
        type === 1 &&
        (this.$refs.title.hasError || this.$refs.Typeselect.hasError || this.$refs.customer.hasError || this.$refs.targetType.hasError || this.form.content.length == 0)
      ) {
        this.$notify(2, this.$t("msg.input_err"), null, false);
        return;
      } else if (type === 2 && (this.$refs.title.hasError || this.$refs.Typeselect.hasError || this.form.content.length == 0)) {
        this.$notify(2, this.$t("msg.input_err"), null, false);
        return;
      }
      if (type === 1) {
        // 1是新增
        this.sendNowMessageDisplay = true;
      } else if (type == 2) {
        // 2是编辑
        this.UpdateMessage();
      }
    },
    confirm(status) {
      console.log(request);
      let publisherType;
      let request = this.form;
      request.publisherId = this.userInfo.id;
      request.publisherType = 1; // 0系统，1管理员，2用户
      request.status = status || 2;
      this.$ajax(1, "post", true, "/system/sentMessage", request)
        .then((res) => {
          if (res.code === 20000) {
            this.getdata(1);
            this.sendNowMessageDisplay = false;
            this.addMessageDispaly = false;
            this.$notify(1, "发送成功", null, false);
            this.form = JSON.parse(JSON.stringify(props.row));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取列表数据
    getdata(index) {
      this.listData = [];
      this.loading = true;
      let request = {};
      if (this.keyword) request.keyword = this.keyword;
      if (this.startTime) {
        let StartTime = this.startTime + " 00:00:00";
        request.startTime = new Date(StartTime).getTime();
      }

      if (this.endTime) {
        let EndTime = this.endTime + " 23:59:59";
        request.endTime = new Date(EndTime).getTime();
      }
      request.paging = {
        index: (index - 1) * this.page.rowsPerPage,
        count: this.page.rowsPerPage,
        sort: "desc",
      };
      // request.customerId = this.custom.id;
      if (this.searcUserId) {
        request.targetId = this.searcUserId;
      }
      this.$ajax(1, "post", true, "/system/Message/list", request)
        .then((res) => {
          if (res.code === 20000) {
            this.listData = res.data;
            this.total = res.paging && res.paging.total ? res.paging.total : 0;
            setTimeout(() => {
              this.loading = false;
            }, 800);
          }
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            this.loading = false;
          }, 800);
          this.$emit("islogin", index == 1 ? 0 : 1, err);
          //if(err.code) this.$notify(2,err.msg,null,false);
        });
    },
    pageClick(type) {
      // 点击页数 type:0-,1+
      this.curPage = type ? this.curPage + 1 : this.curPage - 1;
      if (this.curPage > 0 && this.total !== 0 && this.listData.length < this.total) {
        this.getdata(this.curPage);
      }
    },
  },
};
</script>
